export default class PreislisteZeitraumRequest {
  filialeId: string
  zeitpunkt: string
}
